import { Box, Flex, styled } from '@grupoboticario/flora-react';

export const styles = {
  Wrapper: styled(Box, {
    background: '$backgroundPrimary',
    paddingBottom: '$20',
    width: '100%',
  }),
  ContentWrapper: styled(Flex, {
    flexDirection: 'column',
    gap: '$15',
    width: '100%',
  }),
};

export default styles;
